export default __webpack_public_path__ + "static/media/Ballroll_00100.1be76439.png";